// import React from "react";
// // import { ENV, s3_bucket_prod_url, s3_bucket_uat_url, SUB_DIRECTORY } from "../../common/constant";

import { ENV } from "../../common/constant";

const Contact = ({ zone }) => {
    const normalizedZone = zone?.toUpperCase() ?? "";

   
    const contactData = [
      {
        region: "CO",
        level1: {
          name: "Shweta Dhayfule",
          phone: "8692807003",
          email: "Shweta.Dhayfule@axisbank.com",
        },
        level2: {
          name: "Siddhesh Chandavar",
          phone: "9819240951",
          email: "Siddhesh.Chandavar@axisbank.com",
        },
      },
      {
        region: "West",
        level1: {
          name: "John Doe",
          phone: "9876543210",
          email: "john.doe@axisbank.com",
        },
        level2: {
          name: "Jane Doe",
          phone: "9876543211",
          email: "jane.doe@axisbank.com",
        },
      },
      
      {
        region: "North",
        level1: {
          name: "Sanskar Bhardwaj",
          phone: "8800891578",
          email: "Sanskar.Bhardwaj@axisbank.com",
        },
        level2: {
          name: "Siddhesh Chandavar",
          phone: "9819240951",
          email: "Siddhesh.Chandavar@axisbank.com",
        },
      },
      {
        region: "South",
        level1: {
          name: "Sathish Sankar",
          phone: "9840745651",
          email: "M.Sathishsankar@axisbank.com",
        },
        level2: {
          name: "Siddhesh Chandavar",
          phone: "9819240951",
          email: "Siddhesh.Chandavar@axisbank.com",
        },
      },
      {
        region: "East",
        level1: {
          name: "Sudhansu Padhi",
          phone: "9937032693",
          email: "Sudhansu.Padhi@axisbank.com",
        },
        level2: {
          name: "Siddhesh Chandavar",
          phone: "9819240951",
          email: "Siddhesh.Chandavar@axisbank.com",
        },
      },
    ];
  
    const defaultContacts = [
      {
        level: "Level 1",
        title: "Mr.",
        firstName: "Prakash",
        lastName: "Nayak",
        phone: "8657561714",
        email: "prakash.nayak@pincinsure.com",
      },
      {
        level: "Level 2",
        title: "Ms.",
        firstName: "Kashmira",
        lastName: "Thakur",
        phone: "9920602670",
        email: "Kashmira.thakur@pincinsure.com",
      },
    ];

    // Filter contacts matching zone (handle 'CO' matching 'CO/West')
    const filteredContactData = contactData.filter((item) =>
        normalizedZone === item.region.toUpperCase()
      );
  
  
    return (
      <div className="mb-3 row">
        <span className="fw-bold mb-1">Contact Person</span>
  
        {/* Default contacts */}
        {defaultContacts.map((contact, index) => (
          <div key={`default-${index}`} className={index > 0 ? "mt-1" : ""}>
            <div className="card">
              <div className="card-body">
                <h6 className="mb-1 px-3">{contact.level}</h6>
                <div className="d-flex user-card">
                  <div className="my-auto _info px-3">
                    <h6 className="mb-1">
                      RM : <b>{contact.title} {contact.firstName} </b> {contact.lastName}
                    </h6>
                    <p className="mb-0">
                      <a href={`tel:${contact.phone}`} className="text-primary">
                        <i className="fa fa-phone"></i>Contact No: &nbsp;&nbsp;+91-{contact.phone}
                      </a>
                    </p>
                    <a className="small" href={`mailto:${contact.email}`}>
                      <i className="fa fa-envelope"></i>Email: &nbsp;&nbsp;{contact.email}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
        { ENV === 'prod' &&
        <>
        <span className="fw-bold mb-1 mt-4">Axis Admin Team</span>
  
        {/* Region-specific contacts */}
        {filteredContactData.length > 0 ? (
          filteredContactData.map((region, index) => (
            <div key={`region-${index}`} className="mb-3 mt-2">
              <span className="fw-bold">{region.region} Region</span>
  
              <div className="mt-1">
                <div className="card">
                  <div className="card-body">
                    <h6 className="mb-1 px-3">Level 1</h6>
                    <div className="d-flex user-card">
                      <div className="my-auto _info px-3">
                        <h6 className="mb-1">RM : <b>{region.level1.name}</b></h6>
                        <p className="mb-0">
                          <a href={`tel:${region.level1.phone}`} className="text-primary">
                            <i className="fa fa-phone"></i>Contact No: &nbsp;&nbsp;+91-{region.level1.phone}
                          </a>
                        </p>
                        <a className="small" href={`mailto:${region.level1.email}`}>
                          <i className="fa fa-envelope"></i>Email: &nbsp;&nbsp;{region.level1.email}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <div className="mt-1">
                <div className="card">
                  <div className="card-body">
                    <h6 className="mb-1 px-3">Level 2</h6>
                    <div className="d-flex user-card">
                      <div className="my-auto _info px-3">
                        <h6 className="mb-1">RM : <b>{region.level2.name}</b></h6>
                        <p className="mb-0">
                          <a href={`tel:${region.level2.phone}`} className="text-primary">
                            <i className="fa fa-phone"></i>Contact No: &nbsp;&nbsp;+91-{region.level2.phone}
                          </a>
                        </p>
                        <a className="small" href={`mailto:${region.level2.email}`}>
                          <i className="fa fa-envelope"></i>Email: &nbsp;&nbsp;{region.level2.email}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No contact data available for your region.</p>
        )}
        </>
}
      </div>
    );
  };
  

export default Contact
